import { createSlice } from "@reduxjs/toolkit";


export interface IState {

  error: any,
};

export const initialState: IState = {

  error: {},
};

const SettingSlice = createSlice({
  name: "Setting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Setting

  },
});

export default SettingSlice.reducer;